module.exports = __webpack_public_path__ + "img/icon-delivery-truck-blue.39fe6f43.svg";